import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography, keyframes } from '@mui/material';
import { ThumbUp, ThumbUpOutlined, ThumbDown, ThumbDownOutlined, Refresh, Share, MoreVert } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import BeatLoader from 'react-spinners/BeatLoader';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VolumeUpOutlined from '@mui/icons-material/VolumeUpOutlined';
import axios from 'axios';

// Shake animation
const shake = keyframes`
  0% { transform: rotate(0); }
  25% { transform: rotate(-10deg); }
  50% { transform: rotate(10deg); }
  75% { transform: rotate(-10deg); }
  100% { transform: rotate(0); }
`;

const ChatFeedback = ({ expand, currentSession, text, onClick, user_id, currentSessionId }) => {
    const theme = useTheme();
    const [feedback, setFeedback] = useState({});
    const [isShaking, setIsShaking] = useState(false);
    const [copiedTooltip, setCopiedTooltip] = useState(false);

    // const DATABASE_URL = import.meta.env.VITE_APP_CHATBOT;
    const DATABASE_URL = "";
    const savefeedback = async (data, feedbackType) => {
        try {
            const payload = {
                user_id: user_id,
                session_id: currentSessionId,
                message_id: data.message_id || data.messageId,
                user_Feedback: feedbackType
            };

            const response = await axios.put(`${DATABASE_URL}/sb_chat_bot/updateFeedback`, payload, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.status === 200) {
                console.log('Feedback updated successfully!');
            } else {
                console.error('Error updating feedback:', response.data.error);
            }
        } catch (error) {
            console.error('Error updating feedback:', error);
        }
    };
    const handleFeedback = (currentMessage, feedbackType) => {
        const messageId = currentMessage.message_id || currentMessage.messageId;

        setIsShaking(true);
        setFeedback((prevFeedback) => ({
            ...prevFeedback,
            [messageId]: { feedback: feedbackType }  
        }));
        setTimeout(() => setIsShaking(false), 500);
        
    };

    const handleCopy = () => {
        if (text) {
            navigator.clipboard.writeText(text);
            setCopiedTooltip(true); 
            setTimeout(() => {
                setCopiedTooltip(false);  
            }, 1500);
        }
    };

     
    const handleListen = () => {
        if (text) {
            const speech = new SpeechSynthesisUtterance(text);
            speech.lang = 'en-US'; 
            speech.rate = 1;  
            window.speechSynthesis.speak(speech);
        }
    };

    return (
        <Box sx={{ display: 'flex', gap: expand ? 1 : 0.5, mt: 1 }}>
            <Tooltip title="Like">
                <IconButton
                    onClick={() => {
                        const currentMessage = onClick();  
                        if (!currentMessage) return;  

                        handleFeedback(currentMessage, 'Like');
                        savefeedback(currentMessage, 'Like');
                    }}
                    sx={{
                        color:
                            feedback[onClick()?.message_id || onClick()?.messageId]?.feedback === 'Like'
                                ? theme.palette.secondary.main
                                : 'gray',
                        p: 0.5,
                        animation:
                            isShaking && feedback[onClick()?.message_id || onClick()?.messageId]?.feedback === 'Like'
                                ? `${shake} 0.5s ease-in-out`
                                : 'none',
                        transition: 'color 0.3s ease, background-color 0.3s ease',
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.light
                        }
                    }}
                >
                    {feedback[onClick()?.message_id || onClick()?.messageId]?.feedback === 'Like' ? (
                        <ThumbUp sx={{ fontSize: expand ? '20px' : '18px' }} />
                    ) : (
                        <ThumbUpOutlined sx={{ fontSize: expand ? '20px' : '18px' }} />
                    )}
                </IconButton>
            </Tooltip>

            <Tooltip title="Dislike">
                <IconButton
                    onClick={() => {
                        const currentMessage = onClick(); // Get the value returned from onClick

                        handleFeedback(currentMessage, 'Dislike');
                        savefeedback(currentMessage, 'Dislike');
                    }}
                    sx={{
                        color:
                            feedback[onClick()?.message_id || onClick()?.messageId]?.feedback === 'Dislike'
                                ? theme.palette.secondary.main
                                : 'gray',
                        p: 0.5,
                        animation:
                            isShaking && feedback[onClick()?.message_id || onClick()?.messageId]?.feedback === 'Dislike'
                                ? `${shake} 0.5s ease-in-out`
                                : 'none',
                        transition: 'color 0.3s ease, background-color 0.3s ease',
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.light
                        }
                    }}
                >
                    {feedback[onClick()?.message_id || onClick()?.messageId]?.feedback === 'Dislike' ? (
                        <ThumbDown sx={{ fontSize: expand ? '20px' : '18px' }} />
                    ) : (
                        <ThumbDownOutlined sx={{ fontSize: expand ? '20px' : '18px' }} />
                    )}
                </IconButton>
            </Tooltip>

            {/* Copy Button with Dynamic Tooltip */}
            <Tooltip title={copiedTooltip ? 'Copied!' : 'Copy'} open={copiedTooltip}>
                <IconButton
                    onClick={handleCopy}
                    sx={{
                        color: 'gray',
                        p: 0.7,
                        '&:hover': { backgroundColor: theme.palette.secondary.light }
                    }}
                >
                    <ContentCopyIcon sx={{ fontSize: expand ? '20px' : '18px' }} />
                </IconButton>
            </Tooltip>

            {/* Listen Button */}
            <Tooltip title="Listen">
                <IconButton
                    onClick={handleListen}
                    sx={{
                        color: 'gray',
                        p: 0.7,
                        transition: 'color 0.3s ease, background-color 0.3s ease',
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.light
                        }
                    }}
                >
                    <VolumeUpOutlined sx={{ fontSize: expand ? '22px' : '20px' }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
};

export default ChatFeedback;
